var ExtendedNewsAddon = (function ($) {

    function collapseSelectedMenuItem(sidebarMenuContainer) {
        var selectedMenuItem = sidebarMenuContainer.find(".extended-news-sidebar-menu-item .active").first();
        if (!selectedMenuItem.length) {
            return;
        }

        var upperLevelMenuItem = selectedMenuItem.parent().parent();
        var isMenuItem = upperLevelMenuItem.hasClass("extended-news-sidebar-menu-item");
        while (isMenuItem) {
            upperLevelMenuItem.addClass("open");
            upperLevelMenuItem.children(".extended-news-sidebar-menu-item").show();
            upperLevelMenuItem.children(".extended-news-sidebar-menu-item-label").addClass("active");
            upperLevelMenuItem = upperLevelMenuItem.parent();
            isMenuItem = upperLevelMenuItem.hasClass("extended-news-sidebar-menu-item");
        }
    }

    function onClickMenuItemWithChildren() {
        var menuItemLabel = $(this);
        var menuItemContainer = menuItemLabel.parent();
        var isOpen = menuItemContainer.hasClass("open");

        var lowerLevelMenuItems = menuItemLabel.siblings(".extended-news-sidebar-menu-item");
        if (isOpen) {
            menuItemLabel.removeClass("active");
            menuItemContainer.removeClass("open");
            lowerLevelMenuItems.hide();
        } else {
            menuItemLabel.addClass("active");
            menuItemContainer.addClass("open");
            lowerLevelMenuItems.show();
        }
    }

    function onClickAccordionTitle() {
        var accordionTitle = $(this);
        var accordionContent = accordionTitle.siblings(".extended-news-accordion-content").first();
        var accordionIcon = accordionTitle.find(".accordion-icon").first();

        var isOpen = accordionIcon.hasClass("open");
        if (isOpen) {
            accordionIcon.removeClass("open");
            accordionContent.slideUp();
        } else {
            accordionIcon.addClass("open");
            accordionContent.slideDown();
        }
    }

    function initializeSidebarMenu() {
        var sidebarMenuContainer = $(".extended-news-sidebar-menu-container");
        if (!sidebarMenuContainer.length) {
            return;
        }

        collapseSelectedMenuItem(sidebarMenuContainer);
        sidebarMenuContainer.find(".extended-news-sidebar-menu-item-label").on('click', onClickMenuItemWithChildren);
    }

    function initializeAccordion() {
        var accordionContainer = $(".extended-news-accordion-container");
        if (!accordionContainer.length) {
            return;
        }

        accordionContainer.find(".extended-news-accordion-title").on('click', onClickAccordionTitle);
    }

    function initialize() {
        initializeSidebarMenu();
        initializeAccordion();
    }

    return {
        initialize: initialize
    };

})($);

$(function () {
    ExtendedNewsAddon.initialize();
});